<template>
  <div id="job">
    <section class="job-description light-grey-bg">
      <div class="wrapper">
        <div class="width-70">
          <div class="job-container">
            <h2 class="underline-light">{{ this.job.text }}</h2>
            <p class="job-categories">
              <span class="job-location">{{ this.job.location }}</span>
              <span class="job-team">{{ this.job.team }}</span>
              <span class="job-commitment">{{ this.job.commitment }}</span>
            </p>
            <p v-html="this.parsedDesc"></p>
            <div
              class="job-list-item"
              v-for="listItem in this.job.lists"
              :key="listItem"
            >
              <h3>{{ listItem.text }}</h3>
              <ul v-html="listItem.content"></ul>
            </div>
            <div v-if="this.job.salaryRange !== null" class="job-list-item">
              <h3>Compensation:</h3>
              <p>
                {{ numberformatter(this.job.salaryRange.min) }} -
                {{ numberformatter(this.job.salaryRange.max) }}
                {{ this.job.salaryRange.currency }}
                {{ this.job.salaryRange.interval }}
              </p>
              <p class="job-additional" v-html="this.job.salaryDescription"></p>
            </div>

            <p class="job-additional" v-html="this.job.additional"></p>
          </div>
        </div>
        <div class="width-30 text-center">
          <a id="apply_for_job" class="btn outline" @click="scrollToEnd"
            >Apply Now</a
          >
          <JobSocial :url="this.individualJobUrl" />
        </div>
      </div>
    </section>

    <JobForm :job_id="job.id" />
  </div>
</template>

<script>
import axios from "axios";
import JobSocial from "./JobSocial.vue";
import JobForm from "./JobForm.vue";

export default {
  name: "Job",
  props: ["wpLever"],
  data() {
    return {
      loading: null,
      job: {
        id: null,
        text: null,
        additional: null,
        categories: null,
        description: null,
        lists: null,
        commitment: null,
        team: null,
        location: null,
        salaryRange: null,
        salaryDescription: null,
      },
    };
  },
  computed: {
    // a computed getter
    individualJobUrl: function() {
      return this.base_url + window.location.pathname;
    },
    parsedDesc: function() {
      if (this.job.description) {
        let desc = document.createElement("div");
        desc.innerHTML = this.job.description;
        desc.removeChild(desc.firstElementChild);
        return desc.innerHTML;
      }
      return "";
    },
  },
  components: {
    JobSocial,
    JobForm,
  },
  methods: {
    numberformatter(number) {
      if (number === null || number === undefined) return "N/A";
      return new Intl.NumberFormat("en-US").format(number);
    },
    fetchJob() {
      if (this.loading === false || this.loading === null) {
        this.loading = true;
        axios
          // .post(wpLever.ajaxurl, params) // eslint-disable-line
          .get(
            "https://jobs.lever.co/v0/postings/" +
              wpLever.params.site_url +
              "/" +
              this.job.id
          ) // eslint-disable-line
          .then((response) => {
            this.job.text = response.data.text;
            this.job.description = response.data.description;
            this.job.additional = response.data.additional;
            this.job.categories = response.data.categories;
            this.job.lists = response.data.lists;
            this.job.commitment = response.data.categories.commitment;
            this.job.location = response.data.categories.location;
            this.job.team = response.data.categories.team;

            if (response.data.salaryRange) {
              this.job.salaryRange = response.data.salaryRange;
            } else {
              this.job.salaryRange = null;
            }

            this.job.salaryDescription = response.data.salaryDescription || "";
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.data); // => the response payload
            }
          });
      }
    },
    scrollToEnd: function() {
      const el = this.$el.getElementsByClassName("apply-form")[0];

      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  created() {
    this.job.id = wpLever.job_id; // eslint-disable-line
    this.page_url = wpLever.joburl; // eslint-disable-line
    this.base_url = wpLever.base_url; // eslint-disable-line
    this.fetchJob();
  },
};
</script>
